<template>
  <div id="loginOrReg">
    <!-- 登录弹框 -->
    <van-popup
      v-model="showLogin"
      round
      position="bottom"
      @open="openLogin"
      ref="loginPop"
      get-container="body"
    >
      <div class="loginContent" style="margin: 16px 0px 20px">
        <van-tabs v-model="active" :border="false" line-width="70">
          <van-tab title="账号登录">
            <div class="content" style="padding: 10px 20px 20px">
              <van-cell-group>
                <van-field
                  v-model="account"
                  center
                  clearable
                  placeholder="请输入登录账号"
                  @blur="checkAccount"
                  :error-message="errMsg.account"
                />
                <van-field
                  v-model="password"
                  center
                  clearable
                  type="password"
                  placeholder="请输入登录密码"
                  @blur="changeLoginPwd"
                  :error-message="errMsg.changeLoginPwd"
                />
              </van-cell-group>
              <div
                class="forgetPwdOrReg"
                style="
                  font-size: 14px;
                  margin-top: 30px;
                  display: flex;
                  justify-content: center;
                "
              >
                <span @click="createAccount">注册</span>
                <span style="margin: 0 14px; color: #715641">|</span>
                <span @click="forgotPwd" class="pwd">忘记密码</span>
              </div>
              <div style="margin-top: 30px" @click="beforeLogin(0)">
                <van-button block type="info" style="border-radius: 30px"
                  >登录</van-button
                >
              </div>
            </div>
          </van-tab>
          <van-tab title="验证码登录">
            <div class="content" style="padding: 10px 20px 20px">
              <van-cell-group>
                <van-field
                  v-model="regMoblie"
                  center
                  clearable
                  type="number"
                  maxlength="11"
                  placeholder="请输入11位手机号码"
                  @blur="checkMobile"
                  :error-message="errMsg.mobilePhone"
                />
                <van-field
                  v-model="regCode"
                  center
                  clearable
                  type="number"
                  maxlength="6"
                  placeholder="请输入短信验证码"
                  @blur="changeCode"
                  :error-message="errMsg.code"
                >
                  <template #button>
                    <van-button
                      :disabled="disabled"
                      size="small"
                      type="info"
                      style="
                        background-color: #ccc;
                        color: #fff;
                      "
                      @click="sendcode(2)"
                      >{{ btntxt }}</van-button
                    >
                  </template>
                </van-field>
              </van-cell-group>
              <div
                class="forgetPwdOrReg"
                style="
                  font-size: 14px;
                  margin-top: 30px;
                  display: flex;
                  justify-content: center;
                "
              >
                <span @click="createAccount">注册</span>
                <span style="margin: 0 14px; color: #715641">|</span>
                <span @click="forgotPwd" class="pwd">忘记密码</span>
              </div>
              <div style="margin-top: 30px" @click="beforeLogin(1)">
                <van-button block type="info" style="border-radius: 30px"
                  >登录</van-button
                >
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>

    <!-- 新加start -->
    <!-- 修改账号弹框 发送手机验证码 -->
    <van-popup
      v-model="showNewUpUser"
      round
      position="bottom"
      closeable
      close-icon="close"
      @open="openApplyLogin"
      :style="{ height: '58%' }"
      get-container="body"
    >
      <div class="loginContent" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: 600;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
            "
          >
          修改账号-验证手机号码
          </div>
          <van-cell-group>
            <van-cell center :value="replacephone" />
            <van-field
              v-model="regCode"
              center
              clearable
              type="number"
              maxlength="6"
              placeholder="请输入短信验证码"
              @blur="changeCode"
              :error-message="errMsg.code"
            >
              <template #button>
                <van-button
                  :disabled="disabled"
                  size="small"
                  type="info"
                  style="
                    background-color: #ccc;
                    color: #fff;
                  "
                  @click="sendcode(7)"
                  >{{ btntxt }}</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
          <div style="margin-top: 30px">
            <van-button block type="info" style="border-radius: 30px" @click="beforeUpdateClose"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 新加end -->

    <!-- 申请试用弹框 发送手机验证码 -->
    <van-popup
      v-model="showApplyLogin"
      round
      position="bottom"
      closeable
      @open="openApplyLogin"
      :style="{ height: '58%' }"
      get-container="body"
    >
      <div class="loginContent" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: 600;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
            "
          >
            注册账号
          </div>
          <van-cell-group>
            <van-field
              v-model="regMoblie"
              center
              clearable
              type="number"
              maxlength="11"
              placeholder="请输入11位手机号码"
              @blur="checkMobile"
              :error-message="errMsg.mobilePhone"
            />
            <van-field
              v-model="regCode"
              center
              clearable
              type="number"
              maxlength="6"
              placeholder="请输入短信验证码"
              @blur="changeCode"
              :error-message="errMsg.code"
            >
              <template #button>
                <van-button
                  :disabled="disabled"
                  size="small"
                  type="info"
                  class="reg-sms-btn"
                  @click="sendcode(1)"
                  >{{ btntxt }}</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
          <div style="margin-top: 30px">
            <van-button block type="info" style="border-radius: 30px" @click="beforeApplyLoginClose"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 注册 设置账号和密码 -->
    <van-popup
      v-model="showReg"
      round
      position="bottom"
      closeable
      close-icon="close"
      @open="openReg"
      :style="{ height: '90%' }"
      get-container="body"
    >
      <div class="loginContent" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: 600;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
            "
          >
            设置您的账号及密码
          </div>
          <van-cell-group>
            <van-field
              v-model="account1"
              center
              clearable
              placeholder="账号只能使用数字或字母，长度不超过12位"
              @blur="checkAccount1"
              :error-message="errMsg.account1"
            />
            <van-field
              v-model="password"
              center
              clearable
              type="password"
              placeholder="密码长度至少6位"
              @blur="checkPassword"
              :error-message="errMsg.password"
            />
            <van-field
              v-model="confirmPwd"
              center
              clearable
              type="password"
              placeholder="请输入确认密码"
              @blur="checkConfirmPwd"
              :error-message="errMsg.confirmPwd"
            />
          </van-cell-group>
          <div class="tip" style="margin-top: 20px">
            <van-notice-bar wrapable :scrollable="false">
              <h4>特别提示：</h4>
              <p style="margin: 0 2pt">
                注册成功后，请及时关注微信公众号“众智云擎税法检索”,点击“云擎中心”按钮进入“文件提醒”,即时精准获取税法文件智能推送。
              </p>
            </van-notice-bar>
          </div>
          <div style="margin-top: 30px" @click="beforeReg">
            <van-button
              block
              type="info"
              :disabled="disabledReg"
              style="border-radius: 30px"
              >提交</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 忘记密码 -->
    <van-popup
      v-model="resetPassword"
      round
      position="bottom"
      closeable
      @open="openResetPwd"
      :style="{ height: '60%' }"
      get-container="body"
    >
      <div class="loginContent resetPwd-dialog" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: bold;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
              color:#000000;
            "
          >
            正在重置您的密码
          </div>
          <template>
            <div style="margin-bottom:20px">
              <div style="margin-left:15px">手机号码:</div>
              <van-cell center :value="replacephone" />
            </div>
            <div>
              <div style="margin-left:15px">验证码：</div>
              <van-field
                v-model="regCode"
                center
                clearable
                type="number"
                maxlength="6"
                placeholder="请输入短信验证码"
                @blur="changeCode"
                :error-message="errMsg.code"
              >
                <template #button>
                  <van-button
                    :disabled="disabled"
                    size="small"
                    style="
                      color: #328EFF;
                    "
                    @click="sendcode(3)"
                    >{{ btntxt }}</van-button
                  >
                </template>
              </van-field>

            </div>  
            
          </template>
          <div style="margin-top: 30px" @click="beforeResetPwd">
            <van-button :disabled="!regCode" block type="info" style="border-radius: 30px"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 密码 确认密码 -->
    <van-popup
      v-model="comPassword"
      round
      position="bottom"
      closeable
      @open="openChangePwd"
      :style="{ height: '62%' }"
      get-container="body"
    >
      <div class="loginContent" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: bold;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
              color: #000;
            "
          >
            请输入并确认您的密码
          </div>
          <van-cell-group>
            <van-field
              v-model="password"
              center
              clearable
              type="password"
              placeholder="请输入密码"
              @blur="checkPassword"
              :error-message="errMsg.password"
            />
            <van-field
              v-model="confirmPwd"
              center
              clearable
              type="password"
              placeholder="请输入确认密码"
              @blur="checkConfirmPwd"
              :error-message="errMsg.confirmPwd"
            />
          </van-cell-group>
          <div style="margin-top: 30px" @click="beforeChangePwd">
            <van-button block type="info" style="border-radius: 30px"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 返回-3验证手机号弹框 -->
    <van-popup
      v-model="showCheckPhone"
      round
      position="bottom"
      @open="openLogin"
      get-container="body"
    >
      <div class="loginContent" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: 600;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
            "
          >
            验证手机号
          </div>
          <van-cell-group>
            <van-field
              v-model="regMoblie"
              center
              clearable
              type="number"
              maxlength="11"
              placeholder="请输入11位手机号码"
              @blur="checkMobile"
              :error-message="errMsg.mobilePhone"
            />
            <van-field
              v-model="regCode"
              center
              clearable
              type="number"
              maxlength="6"
              placeholder="请输入短信验证码"
              @blur="changeCode"
              :error-message="errMsg.code"
            >
              <template #button>
                <van-button
                  :disabled="disabled"
                  size="small"
                  type="info"
                  style="
                    background-color: #ccc;
                    color: #fff;
                  "
                  @click="sendcode(4)"
                  >{{ btntxt }}</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
          <div style="margin-top: 30px" @click="checkMobilePhone">
            <van-button block type="info" style="border-radius: 30px"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showLoginForm" position="bottom" :style="{ height: '100%' }" >
      <LoginForm 
        :regMoblie="regMoblie" 
        :agentCode="agentCode" 
        :regCode="regCode" 
        :toLabel="toLabel"
      @closeLoginForm="closeLoginForm"></LoginForm>
    </van-popup>
  </div>
</template>

<script>
import baseConfig from "../../../../public/config.json";
import LoginForm from "../loginForm/index.vue";
import { getSMSFrom } from "@/utils/lib/tools";
import { getTimeStamp } from "@/utils/lib/sign.js";
import TripleDES from "@/utils/lib/crypto.js";
import { commonToast, commonDialog } from "@/utils/lib/toast.js";
import { wxRedirectUrl } from "../../../../public/config.json";


export default {
  data() {
    return {
      showLoginForm: false, // 展示登录信息表格
      codeType: 0,
      showLogin: false, // 登录弹框
      showReg: false, // 注册弹框
      resetPassword: false, // 重置密码弹框
      comPassword: false, // 修改密码 密码 确认密码

      showApplyLogin: false, // 申请试用弹框
      showNewUpUser: false, // 修改账户弹窗

      regMoblie: "", // 申请试用弹框 手机号码
      regCode: "", // 申请试用弹框 验证码
      showCheckPhone: false, // 返回-3验证手机号弹框

      code: "",
      account: "", // 账号
      account1: "", // 注册账号
      password: "", // 密码
      confirmPwd: "", // 确认密码
      active: 0, // 账号登录 验证码登录
      btntxt: "发送验证码",
      disabled: false, // 禁用发送验证码按钮
      time: 0, // 倒计时

      pattern: /^1[3456789]\d{9}$/, // 手机号码验证
      accPattern: /^[0-9a-zA-Z]{1,12}$/, // 验证账号格式 账号只能使用数字、字母、下划线,不超过12位
      errMsg: {
        mobilePhone: "", // 手机号码
        code: "", // 验证码
        account: "", // 账号
        account1: "", // 注册账号
        password: "", // 密码
        confirmPwd: "", // 确认密码
        changeLoginPwd: "", // 登录时验证是否输入密码
      },
      disabledReg: true,

      // 手机账号是否注册
      mobileIsReg: false,
      // 验证码发送成功后
      reqidentity: "",
      strdocid: localStorage.getItem("strdocid"),
      agentCode: "", // 新加
      toLabel: 2
    };
  },
  components: {
    LoginForm
  },
  created () {
    // console.log(this.$route.query.reg);
    // if(this.$route.query.reg) {
    //   this.showApplyLogin = true
    // }
  },
  computed: {
    replacephone:function(){
      let phone=this.$store.state.user.mobileNum
      let reg = /^(.{3}).*(.{4})$/;
      if (phone) {
        return phone.replace(reg, "$1****$2");
      }
    },
    userId() {
      return this.$store.state.user.userId;
    },
    setOwx() {
      return this.$store.state.user.Owx;
    },
    userGuid() {
      return this.$store.state.user.userGuid;
    },
    jumpPage() {
      return this.$store.state.changeVersion.jumpPage;
    },
    phone() {
      return this.$store.state.user.mobileNum;
    },
    // 判断是否是微信浏览器
    // 如果是就显示微信登录  不是就不显示
    isWXBlower() {
      return Number(localStorage.getItem("WX_VERSION"));
    },
    wxopenid() {
      return this.$store.state.user.wxopenid;
    },
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    wxunionid() {
      return this.$store.state.user.wxunionid;
    },
  },
  methods: {
    // 验证手机号码
    checkMobile() {
      if (!this.regMoblie) {
        this.errMsg.mobilePhone = "请输入手机号码";
        return false;
      } else if (!this.pattern.test(this.regMoblie)) {
        this.errMsg.mobilePhone = "手机号码输入有误，请重新输入";
        return false;
      } else {
        this.errMsg.mobilePhone = "";
        return true;
      }
    },
    // 验证申请试用验证码
    changeCode() {
      if (!this.regCode) {
        this.errMsg.code = "请输入验证码";
        return false;
      } else {
        this.errMsg.code = "";
        return true;
      }
    },
    // 注册弹框 验证账号
    checkAccount1() {
      if (!this.account1) {
        this.disabledReg = true;
        this.errMsg.account1 = "请输入账号";
        return false;
      } else if (this.account1.length > 12) {
        this.disabledReg = true;
        this.errMsg.account1 = "账号只能使用数字或字母，长度不超过12位";
        return false;
      } else if (
        this.account1.length <= 12 &&
        !this.accPattern.test(this.account1)
      ) {
        this.disabledReg = true;
        this.errMsg.account1 = "账号只能使用数字或字母，长度不超过12位";
        return false;
      } else {
        this.$http.reqCheckUserId("", this.account1).then((resp) => {
          if (
            resp.rtncode === 1 &&
            resp.rltcode === 1 &&
            resp.enabled === true
          ) {
            this.disabledReg = false;
            this.errMsg.account1 = "";
            return true;
          } else if (
            resp.rtncode === 1 &&
            resp.rltcode === -1 &&
            resp.enabled === false
          ) {
            this.disabledReg = true;
            this.errMsg.account1 = "该账号已被注册，请重新设置";
            return false;
          }
        });
      }
    },
    // 登录弹框 账号登录 验证账号
    checkAccount() {
      if (!this.account) {
        this.errMsg.account = "请输入账号";
        return false;
      } else if (this.account.length > 12) {
        this.errMsg.account = "账号只能使用数字或字母，长度不超过12位";
        return false;
      } else if (
        this.account.length <= 12 &&
        !this.accPattern.test(this.account)
      ) {
        this.errMsg.account = "账号只能使用数字或字母，长度不超过12位";
        return false;
      } else {
        this.errMsg.account = "";
        return true;
      }
    },
    // 登录时验证是否输入密码
    changeLoginPwd() {
      if (!this.password) {
        this.errMsg.changeLoginPwd = "请输入密码";
        return false;
      } else {
        this.errMsg.changeLoginPwd = "";
        return true;
      }
    },
    // 密码
    checkPassword() {
      if (!this.password) {
        this.errMsg.password = "请输入密码";
        return false;
      } else if (this.password.length < 6) {
        this.errMsg.password = "密码长度至少6位";
        return false;
      } else if (this.confirmPwd && this.password !== this.confirmPwd) {
        this.errMsg.confirmPwd = "两次密码不一致";
        return false;
      } else {
        this.errMsg.password = "";
        return true;
      }
    },
    // 确认密码
    checkConfirmPwd() {
      if (!this.confirmPwd) {
        this.errMsg.confirmPwd = "请输入确认密码";
        return false;
      } else if (this.password !== this.confirmPwd) {
        this.errMsg.confirmPwd = "两次密码不一致";
        return false;
      } else {
        this.errMsg.confirmPwd = "";
        return true;
      }
    },
    // 打开登录弹框之前
    openLogin() {
      this.active = 0;
      this.regMoblie = "";
      this.regCode = "";
      this.time = 0;
      this.btntxt = "获取验证码";
      this.disabled = false;
      // this.account = "";
      // this.password = "";
    },
    // 激活手机号
    checkMobilePhone() {
      console.log("激活手机号");
      if (!this.regMoblie || !this.regCode) {
        this.checkMobile();
        this.changeCode();
        this.showCheckPhone = true;
      } else {
        let params = {
          userid: this.account,
          mobilenum: this.regMoblie,
          smscode: this.regCode,
        };
        console.log("激活手机号", params);
        this.$http
          .reqMobileActive(params)
          .then((response) => {
            console.log("激活手机号返回response", response);
            if (response.rtncode === 1 && response.rltcode === 1) {
              commonDialog("激活成功，系统已自动绑定激活账号使用的手机号码,请您重新登录！", this);
              this.showCheckPhone = false;
            }
          })
          .catch((err) => {
            commonDialog(err.message, this);
            this.showCheckPhone = true;
          });
      }
    },
    // 关闭登录弹框之前
    beforeLogin(active) {
      //console.log("登录way===>", this.active);
      if (active === 0) {
        // 账号登录
        if (!this.account || !this.password) {
          this.checkAccount();
          this.changeLoginPwd();
          this.showLogin = true;
        } else {
          let tmpGuid = this.userGuid
          
          if(tmpGuid.indexOf("TMP") == -1) {
            tmpGuid = '';
          } else {
            tmpGuid = localStorage.getItem("userguid");
          }
          let bodyJson = {
            userid: this.account,
            passwd: this.password,
            tempid: tmpGuid,
          };

          this.$http
            .reqLogin(bodyJson)
            .then((response) => {
              if (response.rtncode === 1) {
                if (response.rltcode === 1) {
                  localStorage.setItem('accoutName', this.account)
                  let datapwd = TripleDES.encode("accoutPwd", this.password)
                  localStorage.setItem('accoutPwd', datapwd)
                  
                  if (this.$route.path == '/fileInfo') {
                    location.href = baseConfig.realApiUrl + '/fileInfo' + `?strdocid=${this.strdocid}`
                  }
                  // 登录成功 刷新token
                  this.bus.$emit("saveTokenHandle", response, 0);

                  // 保存账号登录的token和userguid
                  let cookieObjByUserid = {
                    userguid: response.userguid,
                    token: response.token,
                  };
                
                  console.log("cookieObjByUserid", cookieObjByUserid);
                  let data = TripleDES.encode("token", cookieObjByUserid);
                  this.$cookie.set(
                    "cookieObjByUserid",
                    JSON.stringify(data),
                    4
                  );

                  this.showLogin = false;
                  if(this.$route.path =='/policyMate') {
                    //保持当前的路由，政策匹配此页独立
                    this.$emit('refreshProtect')
                  } else {
                    // 登录成功之后 检测用户权限等
                    this.checkUserInfo(response);
                  }
                  
                } else if (response.rltcode === -3) {
                  // 需要激活
                  console.log("弹出验证手机号码");
                  
                  // commonDialog(response.rltdesc, this);
                  this.$dialog.alert({
                    message: response.rltdesc,
                  }).then(() => {
                    this.showCheckPhone = true;
                  });
                } else {
                  commonDialog(response.rltdesc, this);
                  this.showLogin = true;
                }
              } else {
                commonDialog(response.rtndesc, this);
                this.showLogin = true;
              }
            })
            .catch((err) => {
              commonDialog(err.message, this);
              this.showLogin = true;
            });
        }
      } else if (active === 1) {
        // 验证码登录
        if (!this.regMoblie || !this.regCode) {
          this.checkMobile();
          this.changeCode();
          this.showLogin = true;
        } else {
          let bodyJson = {
            mobilenum: this.regMoblie,
            smscode: this.regCode,
            tempid: this.userGuid,
          };

          this.$http
            .reqRegCheckSmsCode(
              this.regMoblie,
              this.regCode,
              getSMSFrom.SMS_CODE_TYPE_MOBILE_LOGIN
            )
            .then((response) => {
              if (response.rtncode === 1) {
                if (response.rltcode === 1) {
                  this.$http
                    .reqSMSLogin(bodyJson)
                    .then((response) => {
                      console.log("response登录成功之后的数据", response);
                      if (response.rtncode === 1) {
                        if (response.rltcode === 1) {
                          this.bus.$emit("saveTokenHandle", response, 0);

                          this.showLogin = false;
                          // 登录成功之后 获取文件夹
                          this.checkUserInfo(response);
                        } else {
                          commonDialog(response.rltdesc, this);
                          this.showLogin = true;
                        }
                      } else {
                        commonDialog(response.rtndesc, this);
                        this.showLogin = true;
                      }
                    })
                    .catch((err) => {
                      commonDialog(err.message, this);
                      this.showLogin = true;
                    });
                } else {
                  commonDialog(response.rltdesc, this);
                  this.showLogin = true;
                }
              } else {
                commonDialog(response.rtndesc, this);
                this.showLogin = true;
              }
            })
            .catch((err) => {
              commonDialog(err.message, this);
              this.showLogin = true;
            });
        }
      }
    },
    // 验证登录之后的身份
    checkUserInfo(response) {
      if (response.accountstatus == 100) {
        // 试用期
        if (response.showmsg && response.showmallbutton) {
          this.showMsgDialog(response.showmsg);
          return;
        }
        if (
          this.$route.name === "NewFiles" &&
          localStorage.getItem("WX_VERSION") === "0"
        ) {
          this.$router.replace({
            path: "/",
          });
          return;
        }
        this.$router.push("/main");
      } else if (response.accountstatus == 107) {
        // 试用期到期7天内
        if (response.showmsg && response.showmallbutton) {
          this.showMsgDialog(response.showmsg);
        }
      } else if (response.accountstatus == 207) {
        // 正常使用到期7天内
        if (response.showmsg && response.showmallbutton) {
          this.showMsgDialog(response.showmsg);
        }
      } else if (response.accountstatus == 300) {
        // 试用期满进入冻结期
        // this.onlygoMall(response.showmsg);
        if (response.showmsg && response.showmallbutton) {
          this.onlygoMall(response.showmsg);
        }
      } else if (response.accountstatus == 400) {
        // 正常使用到期进入冻结期 只能浏览商城
        if (response.showmsg && response.showmallbutton) {
          this.onlygoMall(response.showmsg);
        }
      } else if (response.accountstatus == 200) {
        // 正常使用
        if (response.showmsg && response.showmallbutton) {
          commonDialog(response.showmsg, this, "确定", this.loginsuccessgo);
        } else {
          console.log("8***")
          this.loginsuccessgo();
        }
      } else if (response.showmallbutton) {
        this.onlygoMall(response.showmsg);
      } else if (response.showmsg) {
        this.showMsgDialog(response.showmsg);
      } else {
        if (this.$route.path == '/fileInfo') {
          console.log('2ha', localStorage.getItem("strdocid"))
          location.href = baseConfig.realApiUrl + '/fileInfo' + `?strdocid=${this.strdocid}`
          // this.$router.push({
          //   path: '/fileInfo' + `?strdocid=${this.strdocid}`
          // })
        } else {
          this.$router.push("/newFiles");
        }
      }
      if (response.isupbaseproductnotice) {
        this.$dialog.confirm({
          title: '提示',
          message: `已为您免费升级至专业版，谢谢您的支持与厚爱！`
        }).then(() => {
          this.$http.reqUpdateNotice({
            state: upBaseProductNotice
          }).then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                console.log('通知状态更新成功')
              } else {
                commonDialog(res.rltdesc, this);
              }
            } else {
              commonDialog(res.rtndesc, this);
            }
          });
        })
      }
    },
    // 登录成功跳转
    loginsuccessgo() {
      if (this.jumpPage === 0) {
        if (
          this.$route.name === "NewFiles" &&
          localStorage.getItem("WX_VERSION") === "0"
        ) {
          this.$router.replace({
            path: "/",
          });
          return;
        }
        this.$router.replace({ path: "/main" });
      } else if (this.jumpPage === 1) {
        this.$router.replace({ path: "/searchEngine" });
      } else if (this.jumpPage === 2) {
        this.$router.replace({ path: "/smartcloud" });
      }
      this.$emit("updateDoc"); // 更新doc文件的内容
    },
    // 普通提示弹框
    showMsgDialog(showmsg) {
      this.$dialog
        .alert({
          title: "提示",
          message: showmsg,
        })
        .then(() => {
          if (this.$store.state.user.permissionArray.includes("900001")) {
            this.$router.push("onlineMall");
          }
        })
        .catch(() => {
          this.$router.push("/newFiles");
          // 取消
        });
    },
    // 300 400提示弹框
    onlygoMall(showmsg) {
      this.$dialog
        .confirm({
          title: "提示",
          message: showmsg,
          confirmButtonText: "在线商城",
          cancelButtonText: "退出登录",
        })
        .then(() => {
          if (this.$store.state.user.permissionArray.includes("900001")) {
            this.$router.push("onlineMall");
          }
        })
        .catch(() => {
          sessionStorage.clear();
          localStorage.removeItem('accoutName')
          localStorage.removeItem('accoutPwd')

          this.$cookie.delete("cookieObj");
          console.log(this.$store.state.changeSomeThing.loginWay);
          this.$store.commit("user/setUserId", "");

          if (this.$store.state.changeSomeThing.loginWay == 0) {
            this.$cookie.delete("cookieObjByUserid");
          } else if (this.$store.state.changeSomeThing.loginWay == 1) {
            this.$cookie.delete("cookieObjByWx");
          }
          location.reload();
        });
    },
    // 关闭更新账号弹窗之前
    beforeUpdateClose () {
      this.showNewUpUser = true;
      this.$http
        .reqRegCheckSmsCode(
          this.regMoblie,
          this.regCode,
          7
        )
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              this.showReg = true;
              this.showNewUpUser = false;
            } else {
              commonDialog(response.rltdesc, this);
            }
          } else {
            commonDialog(response.rtndesc, this);
          }
        })
        .catch((err) => {
          commonDialog(err.message, this);
        });
        return false
    },
    // 子组件关闭
    closeLoginForm() {
      this.showLoginForm = false
    },
    // 关闭申请试用弹框 | 绑定账号弹框之前
    beforeApplyLoginClose() {
      //this.showReg = true;
      if (!this.regMoblie || !this.regCode) {
        this.checkMobile();
        this.changeCode();
        this.showApplyLogin = true;
      } else {
        this.$http.reqRegCheckSmsCode(
            this.regMoblie,
            this.regCode,
            getSMSFrom.SMS_CODE_TYPE_REG
          )
          .then((response) => {
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                // 新加 start
                this.showLoginForm = true;
                // this.showReg = true;
                this.showApplyLogin = false;
              } else {
                commonDialog(response.rltdesc, this);
                this.showApplyLogin = true;
              }
            } else {
              commonDialog(response.rtndesc, this);
              this.showApplyLogin = true;
            }
          })
          .catch((err) => {
            commonDialog(err.message, this);
            this.showApplyLogin = true;
          });
        // if (
        //   this.userId != "" &&
        //   this.wxgenerateid != "" &&
        //   this.userId === this.wxgenerateid
        // ) {
        //   console.log('000')
        //   // 是微信登录之后
        //   this.$http
        //     .reqRegCheckSmsCode(
        //       this.$store.state.user.mobileNum,
        //       this.regCode,
        //       getSMSFrom.UPDATE_USER
        //     )
        //     .then((resp /* 验证手机号和验证码 */) => {
        //       console.log("微信登录之后验证手机号和验证码===>", resp);
        //       if (resp.rtncode === 1) {
        //         if (resp.rltcode === 1) {
        //           this.showReg = true;
        //           this.showNewUpUser = false;
        //         } else {
        //           commonDialog(resp.rltdesc, this);
        //           this.showApplyLogin = true;
        //         }
        //       } else {
        //         commonDialog(resp.rtndesc, this);
        //         this.showApplyLogin = true;
        //       }
        //     });
        // }  else {
        //   console.log('#333')
        // }
      }
    },
    // 打开注册弹框
    openReg() {
      this.account1 = "";
      this.password = "";
      this.confirmPwd = "";
    },
    // 关闭注册弹框之前
    beforeReg() {
      if (!this.account1 || !this.password || !this.confirmPwd) {
        this.checkAccount1();
        this.checkPassword();
        this.checkConfirmPwd();
        this.showReg = true;
      } else if (this.errMsg.password !== "" || this.errMsg.confirmPwd !== "") {
        this.showReg = true;
      } else {
        let bodyJson;
        if (
          this.userId != "" &&
          this.wxgenerateid != "" &&
          this.userId === this.wxgenerateid
        ) {
          // 是微信登录之后注册
          bodyJson = {
            userid: this.account1,
            password: this.password,
            mobilenum: this.regMoblie,
            smscode: this.regCode,
            reqidentity: this.reqidentity,
          };
          this.$http
            .reqPostWeixinCreateUser(bodyJson)
            .then((response) => {
              console.log("微信登录之后注册res===>", response);
              if (response.rtncode === 1) {
                if (response.rltcode === 1) {
                  commonDialog("修改账号成功", this);
                  this.showReg = false;

                  // 注册成功之后 文件夹创建默认目录
                  this.$http.reqCreateDefault().then((res) => {
                    if (res.rtncode === 1) {
                      if (res.rltcode === 1) {
                        //
                      }
                    }
                  });

                  this.$http
                    .refreshToken()
                    .then((res) => {
                      this.bus.$emit("saveTokenHandle", res, 0);
                    })
                    .catch((err) => {
                      console.log("微信创建账号刷新token出错====>", err);
                    });
                } else {
                  commonDialog(response.rltdesc, this);
                  this.showReg = true;
                }
              } else {
                commonDialog(response.rtndesc, this);
                this.showReg = true;
              }
            })
            .catch((err) => {
              commonDialog(err.message, this);
              this.showReg = true;
            });
        }  else if(this.userId != "" && this.wxgenerateid === '' ) {
            bodyJson = {
              userid: this.account1,
              password: this.password,
              smscode: this.regCode
            };
           // 修改成功之后 文件夹创建默认目录
            this.$http.reqPostWeixinUpdateUser(bodyJson).then((res) => {
              if (res.rtncode === 1) {
                if (res.rltcode === 1) {
                  commonDialog("修改账号成功", this);
                  this.$store.commit("user/setUserId", this.account1);
                 sessionStorage.setItem("userId", this.account1);
                  this.$http.refreshToken().then((res) => {
                    this.bus.$emit("saveTokenHandle", res, 0);
                  });

                  this.showReg = false;
                } else {
                  commonDialog(res.rltdesc, this);
                  this.showReg = false;
                }
              }  else {
                  commonDialog(res.rtndesc, this);
                  this.showReg = false;
              }
            });
        } else {
          bodyJson = {
            mobilenum: this.regMoblie,
            userid: this.account1,
            password: this.password,
            tempuserguid: this.userGuid,
            smscode: this.regCode,
            unitname: "",
          };

          this.$http
            .reqReg(bodyJson)
            .then((response) => {
              if (response.rtncode === 1) {
                if (response.rltcode === 1) {
                  this.showReg = false;
                  commonDialog("注册成功，请登录", this);
                  // 注册成功之后 文件夹创建默认目录
                  this.$http.reqCreateDefault().then((res) => {
                    if (res.rltcode === 1) {
                      if (res.rltcode === 1) {
                        //
                      }
                    }
                  });
                  
                } else {
                  commonDialog(response.rltdesc, this);
                  this.showReg = true;
                }
              } else {
                commonDialog(response.rtndesc, this);
                this.showReg = true;
              }
            })
            .catch((err) => {
              commonDialog(err.message, this);
              this.showReg = true;
            });
        }
      }
    },
    // 打开重置密码框之前
    openChangePwd() {
      this.password = "";
      this.confirmPwd = "";
    },
    // 关闭重置密码框之前
    beforeChangePwd() {
      this.checkPassword();
      this.checkConfirmPwd();
      if (!this.password || !this.confirmPwd) {
        this.comPassword = true;
      } else if (this.errMsg.password !== "" || this.errMsg.confirmPwd !== "") {
        this.comPassword = true;
      } else {
        let bodyJson = {
          telnum: this.regMoblie,
          pwd: this.password,
          smscode: this.regCode,
        };
        this.$http
          .reqSetPwd(bodyJson.telnum, bodyJson.pwd, bodyJson.smscode)
          .then((response) => {
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.comPassword = false;
                // this.showLogin = true
                commonDialog("密码重置成功，请重新登录", this);
                sessionStorage.removeItem("userId");
                sessionStorage.removeItem("phone");
                sessionStorage.removeItem("userguid");
                sessionStorage.removeItem("token");
                this.$store.commit("user/setUserId", "");
                this.$store.commit("user/setUserGuid", "");
                this.$store.commit("user/setToken", "");
                this.$store.commit("user/setMobileNum", "");

                this.$cookie.delete("cookieObj");

                this.$router.push("index");
              } else {
                commonDialog(response.rltdesc, this);
                this.comPassword = true;
              }
            } else {
              commonDialog(response.rtndesc, this);
              this.comPassword = true;
            }
          })
          .catch((err) => {
            commonDialog(err.message, this);
            this.comPassword = true;
          });
      }
    },
    // 打开忘记密码弹框之前
    openResetPwd() {
      this.regMoblie = "";
      this.regCode = "";
      this.time = 0;
      this.btntxt = "获取验证码";
      this.disabled = false;
    },
    // 关闭忘记密码弹框之前
    beforeResetPwd() {
      if (!this.regMoblie || !this.regCode) {
        this.checkMobile();
        this.changeCode();
        this.resetPassword = true;
      } else {
        this.$http
          .reqRegCheckSmsCode(
            this.regMoblie,
            this.regCode,
            getSMSFrom.SMS_CODE_TYPE_UPDATE_PWD
          )
          .then((response) => {
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.comPassword = true;
                this.resetPassword = false;
              } else {
                commonDialog(response.rltdesc, this);
                this.resetPassword = true;
              }
            } else {
              commonDialog(response.rtndesc, this);
              this.resetPassword = true;
            }
          })
          .catch((err) => {
            commonDialog(err.message, this);
            this.resetPassword = true;
          });
      }
    },
    // 改变showLogin
    changeShowLogin(val) {
      this.showLogin = val;
    },
   
    // 改变resetPassword  修改密码
    changeResetPassword(val) {
      this.resetPassword = val;
    },
    // 打开修改账号弹窗
    openEditUser() {
      this.showLogin = false;
      this.showNewUpUser = true;
    },
     // 改变showApplyLogin
    changeShowApplyLogin(val) {
      if(this.$route.path =='/policyMate') {
        //当前的路由为政策匹配页时，注册替换为拉起微信注册弹窗
        this.createAccount()
      } else {
        this.showApplyLogin = val;
      }
    },
    // 创建账号按钮
    createAccount() {
      // 路径为policyMate时申请试用默认使用微信授权注册
      if(this.$route.path =='/policyMate') {
        this.WXLogIn()
        localStorage.setItem("matching", true);
      } else {
        this.showLogin = false;   
        this.showApplyLogin = true;
      }
    },
    // 微信注册
    WXLogIn() {
      let req = {
        http_redirct: wxRedirectUrl,
      };
      this.$http
        .reqPostGetWeixinPromise(req)
        .then((res) => {
          console.log("res001", res); // 返回的
          location.href = res.item.url;
        })
    },
    // 忘记密码按钮
    forgotPwd() {
      this.showLogin = false;
      this.resetPassword = true;
    },
    // 发送验证码
    sendcode(num) {
      if (num === 1) {
        // 申请试用
        this.codeType = getSMSFrom.SMS_CODE_TYPE_REG;
      } else if (num === 2) {
        // 登录
        this.codeType = getSMSFrom.SMS_CODE_TYPE_MOBILE_LOGIN;
      } else if (num === 3) {
        // 修改密码
        this.codeType = getSMSFrom.SMS_CODE_TYPE_UPDATE_PWD;
        this.regMoblie=this.$store.state.user.mobileNum;
      } else if (num === 4) {
        this.codeType = getSMSFrom.SMS_CODE_TYPE_CHECK_PHONE;
      } else if (num === 7) {
        this.codeType = 7;
        this.regMoblie=this.$store.state.user.mobileNum;
      }

      // 发送验证码接口参数
      let getSmsCodeReqObj = {
        mobilenum: this.regMoblie,
        reqsrc: this.codeType,
      };

      console.log('obj',getSmsCodeReqObj)
      // 微信登录绑定账号
        this.$http.reqSmsCode(getSmsCodeReqObj).then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              commonDialog("验证码发送成功", this);
              this.time = 60;
              this.disabled = true;
              this.timer();
            } else {
              commonDialog(response.rltdesc, this);
            }
          } else {
            commonDialog(response.rtndesc, this);
          }
        });
    },
    // 打开申请试用弹框
    openApplyLogin() {
      this.regMoblie = "";
      this.regCode = "";
      this.time = 0;
      this.btntxt = "获取验证码";
      this.disabled = false;
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    // 获取云端固定文件夹
    getFixedFolder() {
      this.$http.reqGetFixedFolder().then((response) => {
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            this.$store.dispatch(
              "fixedFolder/updateFixedFolderArr",
              response.item
            );
            localStorage.setItem(
              "fixedFolderArr",
              JSON.stringify(response.item)
            );
          }
        }
      });
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
/deep/.van-popup__close-icon {
  color: #000;
}
.resetPwd-dialog {
  /deep/.van-cell {
    margin-top: 0px;
    border: none;
    border-bottom: 1px solid #ededef;
    min-height: 40px;
    border-radius: 0;
  }
}
#loginOrReg {
  
  .loginContent {
    margin: 16px 0px 20px;
    .content {
      padding: 10px 20px 20px;
      .title {
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        color: @--base-word-color;
        margin-bottom: 28px;
      }
      .tip {
        margin-top: 20px;
      }
      .forgetPwdOrReg {
        font-size: 14px;
        margin-top: 30px;
        display: flex;
        justify-content: center;
      }
    }
  }
  
}
.otherLoginWay {
  display: flex;
  justify-content: center;
  align-items: center;
  .WXLogin {
    text-align: center;
    img {
      width: 30px;
      height: 30px;
    }
    p {
      font-size: 12px;
    }
  }
}
.van-cell {
  border: 1px solid #ededef;
  margin-top: 20px;
  border-radius: 6px;
  min-height: 50px;
}
.van-popup--bottom.van-popup--round {
  border-radius: 10px 10px 0 0;
}
/deep/.van-cell:not(:last-child)::after {
  border-bottom: none;
}
/deep/.van-field__control {
  font-size: 12px;
}
.reg-sms-btn {
  background-color: #ccc;
  color: #fff;
}
</style>
